import { useQuery } from '@tanstack/react-query';
import { supabase } from './supabase';

const PLAN_DISPLAY_NAMES: Record<string, string> = {
  free: 'Free Trial',
  starter: 'Starter',
  growth: 'Growth',
  scale: 'Scale',
};

// Display prices for the plans page and onboarding; Stripe holds the real ones.
export const PLAN_PRICES = {
  starter: { monthly: '$59/month', yearly: '$599/year' },
  growth: { monthly: '$129/month', yearly: '$1,299/year' },
  scale: { monthly: '$299/month', yearly: '$2,999/year' },
} as const;

export const getPlanDisplayName = (dbPlan: string) =>
  PLAN_DISPLAY_NAMES[dbPlan] || dbPlan.charAt(0).toUpperCase() + dbPlan.slice(1);

// Prompt limits per plan, from the database that enforces them. Empty until loaded.
export function usePlanPromptLimits(): Record<string, number> {
  const { data = {} } = useQuery({
    queryKey: ['plan_prompt_limits'],
    queryFn: async () => {
      const { data, error } = await supabase.from('plan_prompt_limits').select('plan, prompt_limit');
      if (error) throw error;
      return Object.fromEntries(data.map((row) => [row.plan, row.prompt_limit]));
    },
    staleTime: Infinity,
  });
  return data;
}

// The Stripe customer portal for the signed-in user's Customer; null if they have none.
export async function openCustomerPortal(userId: string, returnUrl: string): Promise<string | null> {
  try {
    const { data, error } = await supabase.functions.invoke('create-portal-session', {
      body: { userId, returnUrl },
    });
    if (error) throw error;
    return data?.url || null;
  } catch (error) {
    console.error('Portal error:', error);
    return null;
  }
}
